import React from 'react';
import { GeoJSON, Popup } from 'react-leaflet';
import L from 'leaflet';

const BusLinesLayer = ({ busLines }) => {
  if (!busLines || busLines.length === 0) return null;

  const onEachFeature = (feature, layer) => {
    // Effet hover simple
    layer.on('mouseover', () => layer.setStyle({ weight: 5, opacity: 1 }));
    layer.on('mouseout', () => layer.setStyle({ weight: 3, opacity: 0.8 }));
  };

  return (
    <>
      {busLines.map((line) => (
        <GeoJSON
          key={line.id}
          data={line.geojsonData}
          style={{
            color: line.color || '#007bff',
            weight: 3,
            opacity: 0.8
          }}
          onEachFeature={onEachFeature}
        >
          <Popup maxWidth={350} minWidth={250}>
            <div style={{ textAlign: 'center', padding: '8px' }}>
              <h4 style={{ margin: '0 0 8px 0', color: line.color || '#007bff' }}>
                {line.name || 'Ligne de bus'}
              </h4>
              <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>Cette année, un parcours spécial est proposé à chaque visiteur de la Ville de Noël. Pour profiter un maximum de la magie de Noël, rien de plus simple : suivez la ligne bleue et laissez-vous guider au milieu de toute cette féérie !</p>
            </div>
          </Popup>
        </GeoJSON>
      ))}
    </>
  );
};

export default BusLinesLayer;
